import store from "@/store/index.store"

import MainLayout from "@/layouts/MainLayout.vue"
import BannerLayout from "@/layouts/BannerLayout.vue"

import { ROUTER_NAMES } from "@/constants/router.constants"
import { GAME_KEYS } from "@/store/game/game.constants"

const SSBUImageBackground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL3N1cGVyLXNtYXNoLWJyb3MtdWx0aW1hdGUvZ2FtZS1iYW5uZXJfYmFja2dyb3VuZC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjE5MjAsImhlaWdodCI6Mjc5LCJmaXQiOiJjb3ZlciJ9fX0="
const SSBUImageForeground =
  "https://d1ni87qrzj7kv2.cloudfront.net/eyJidWNrZXQiOiJwcm9ndWlkZXMtYXNzZXRzIiwia2V5IjoiYXNzZXRzL2dhbWVzL3N1cGVyLXNtYXNoLWJyb3MtdWx0aW1hdGUvZ2FtZS1iYW5uZXJfZm9yZWdyb3VuZC5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjY2MSwiaGVpZ2h0IjoyNTAsImZpdCI6ImNvdmVyIn19fQ=="

// SSBU Pages
// const SSBU = () => import(/* webpackChunkName: "ssbu-resources" */ "@/pages/ssbu/SSBU")
const SSBUTierList = () =>
  import(/* webpackChunkName: "ssbu-resources" */ "@/pages/ssbu/SSBUTierList")
const SSBUCharacterPage = () =>
  import(
    /* webpackChunkName: "ssbu-resources" */ "@/pages/ssbu/SSBUCharacterPage"
  )
const SSBUBannerCoachingCta = () =>
  import(
    /* webpackChunkName: "ssbu-resources" */ "@/components/ssbu/SSBUBannerCoachingCta"
  )

export default [
  {
    path: "/super-smash-bros-ultimate/characters",
    name: ROUTER_NAMES.SSBU_TIER_LIST,
    component: SSBUTierList,
    meta: {
      game: GAME_KEYS.SSBU,
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: SSBUImageBackground,
            bannerImageForeground: SSBUImageForeground,
            bannerContentComponent: SSBUBannerCoachingCta,
          },
        },
      },
    },
    beforeEnter: (_to, from, next) => {
      store.dispatch("SSBU/loadStaticData")
      next()
    },
  },
  {
    path: "/super-smash-bros-ultimate/characters/:characterKey",
    name: ROUTER_NAMES.SSBU_CHARACTER_PAGE,
    component: SSBUCharacterPage,
    meta: {
      game: GAME_KEYS.SSBU,
      layout: {
        component: MainLayout,
        child: {
          component: BannerLayout,
          props: {
            bannerImageBackground: SSBUImageBackground,
            bannerImageForeground: SSBUImageForeground,
            bannerContentComponent: SSBUBannerCoachingCta,
          },
        },
      },
    },
    beforeEnter: (to, from, next) => {
      store.dispatch("SSBU/loadStaticData")
      store.dispatch("SSBU/loadCharacterGuides", to.params.characterKey)
      next()
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/ssbu.routes.js